export default function TrustSafety() {
  const trustFeatures = [
    {
      icon: 'ri-shield-check-fill',
      title: 'Providers are ID-verified'
    },
    {
      icon: 'ri-shield-star-fill',
      title: 'DBS checked & fully insured'
    },
    {
      icon: 'ri-secure-payment-fill',
      title: 'Secure in-app payments'
    },
    {
      icon: 'ri-customer-service-2-fill',
      title: 'Support available if something goes wrong'
    }
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 animate-on-scroll">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Trust & Safety
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Your security is our top priority
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {trustFeatures.map((feature, index) => (
            <div
              key={index}
              className="group text-center p-6 bg-gradient-to-br from-gray-50 to-white rounded-2xl border-2 border-gray-100 hover:border-orange-500 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 animate-on-scroll"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto flex items-center justify-center bg-orange-50 rounded-2xl mb-4 sm:mb-6 group-hover:bg-orange-500 group-hover:scale-110 group-hover:rotate-12 transition-all duration-500">
                <i className={`${feature.icon} text-3xl sm:text-4xl text-orange-500 group-hover:text-white transition-colors duration-500`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 group-hover:text-orange-500 transition-colors duration-300">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
